import { RouteRecordRaw } from 'vue-router';

import { FilterType } from '../models/filter';
import { PortalDefinition } from '../models/definition';
import SearchResults from '../presentation/components/search-results/SearchResults.vue';
import { BaseRoutes } from './BaseRoutes';
import RoutingDefinitions from './RoutingDefinitions';

export class Routes extends BaseRoutes {
	public getRoutes(portalDefinition: PortalDefinition): RouteRecordRaw[] {
		const routes = super.getRoutes(portalDefinition);

		const degreeTypeRegex = portalDefinition.getFilterDefinition(FilterType.DEGREE_TYPE).getPathRegex();
		const disciplinesRegex = portalDefinition.getFilterDefinition(FilterType.DISCIPLINES).getPathRegex();
		const countryRegex = portalDefinition.getFilterDefinition(FilterType.COUNTRY).getPathRegex();
		const deliveryMethodRegex = portalDefinition.getFilterDefinition(FilterType.DELIVERY_METHOD).getPathRegex();
		const durationRegex = portalDefinition.getFilterDefinition(FilterType.DURATION).getPathRegex();
		const specialProgrammesRegex = portalDefinition.getFilterDefinition(FilterType.SPECIAL_PROGRAMMES).getPathRegex();
		const formatRegex = portalDefinition.getFilterDefinition(FilterType.ATTENDANCE).getPathRegex();

		const COUNTRY_DEGREE_TYPE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:country(${countryRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_DEGREE_TYPE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter
		};
		const COUNTRY_ATTENDANCE_ROUTE = {
			path: `:delivery_method(${deliveryMethodRegex})/:country(${countryRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_ATTENDANCE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter
		};
		const COUNTRY_FORMAT_ROUTE = {
			path: `:country(${countryRegex})/:attendance(${formatRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_FORMAT_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter
		};
		const COUNTRY_ATTENDANCE_DEGREE_TYPE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:delivery_method(${deliveryMethodRegex})/:country(${countryRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_ATTENDANCE_DEGREE_TYPE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter
		};
		const COUNTRY_DEGREE_TYPE_DURATION_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:duration(${durationRegex})/:country(${countryRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.COUNTRY_DEGREE_TYPE_DURATION_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter
		};
		const DISCIPLINE_DEGREE_TYPE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:discipline(${disciplinesRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.DISCIPLINE_DEGREE_TYPE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
		};
		const ATTENDANCE_DEGREE_TYPE_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:delivery_method(${deliveryMethodRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.ATTENDANCE_DEGREE_TYPE_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter
		};
		const DISCIPLINE_DEGREE_TYPE_COUNTRY_ROUTE = {
			path: `:degree_type(${degreeTypeRegex})/:discipline(${disciplinesRegex})/:country(${countryRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.DISCIPLINE_DEGREE_TYPE_COUNTRY_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
		};
		const SPECIAL_PROGRAMMES_ROUTE = {
			path: `:special_programmes(${specialProgrammesRegex})/:page(page-2)?`,
			component: SearchResults,
			name: RoutingDefinitions.SPECIAL_PROGRAMMES_ROUTE,
			beforeEnter: RoutingDefinitions.beforeEnter
		};

		routes.push(
			COUNTRY_DEGREE_TYPE_ROUTE,
			COUNTRY_ATTENDANCE_ROUTE,
			COUNTRY_FORMAT_ROUTE,
			COUNTRY_ATTENDANCE_DEGREE_TYPE_ROUTE,
			COUNTRY_DEGREE_TYPE_DURATION_ROUTE,
			DISCIPLINE_DEGREE_TYPE_ROUTE,
			DISCIPLINE_DEGREE_TYPE_COUNTRY_ROUTE,
			ATTENDANCE_DEGREE_TYPE_ROUTE,
			SPECIAL_PROGRAMMES_ROUTE
		);

		return routes;
	}
}
